export default {
  site_name: 'CSSBuy Spreadsheet',
  home: 'Startseite',
  categories: 'Kategorien',
  guides: 'Anleitungen',
  search: 'Suche',
  search_placeholder: 'Produkt, Kategorie oder Stichwort suchen...',
  language: 'Sprache',
  hero_title: 'CSSBuy Spreadsheet: Produkte finden und vergleichen',
  hero_subtitle: 'Entdecken Sie die CSSBuy Spreadsheet, finden Sie Produkte, vergleichen Sie Optionen und sehen Sie Anleitungen zu QC, Versand, Kosten, Lager, Sicherheit und Einkauf.',
  explore_spreadsheet: 'CSSBuy Spreadsheet erkunden',
  buy_now: 'Buy It Now',
  view_full_guide: 'Vollständige Anleitung ansehen',
  trust_text: 'Unabhängige Ressource · Aktualisierter Inhalt · Organisierte Recherche · PT-BR + English + Deutsch',
  popular_categories: 'Beliebte Kategorien',
  shoes: 'Schuhe',
  hoodies_sweaters: 'Hoodies / Pullover',
  t_shirts: 'T-Shirts',
  jackets: 'Jacken',
  pants_shorts: 'Hosen / Shorts',
  headwear: 'Kopfbedeckungen',
  sets: 'Sets',
  underwear: 'Unterwäsche',
  jersey: 'Trikots',
  accessories: 'Accessoires',
  bags: 'Taschen',
  belts: 'Gürtel',
  perfumes: 'Parfums',
  other_stuff: 'Sonstiges',
  why_spreadsheet: 'Warum die CSSBuy Spreadsheet nutzen?',
  organized_research: 'Organisierte Recherche',
  organized_research_desc: 'Finden Sie Produktinformationen in einer einfachen und organisierten Struktur.',
  compare_options: 'Optionen vergleichen',
  compare_options_desc: 'Vergleichen Sie Kategorien, Verkäufer und Informationen vor dem Kauf.',
  qc_guide: 'QC-Anleitung',
  qc_guide_desc: 'Verstehen Sie, welche Punkte vor dem Kauf zu prüfen sind.',
  save_time: 'Zeit sparen',
  save_time_desc: 'Finden Sie Produkte mit Suche und Filtern schnell und effizient.',
  cssbuy_review: 'CSSBuy Review 2026',
  review_desc: 'Überprüfen Sie Informationen zu Funktionen, QC, Lager, Versand, Kosten und möglichen Risiken.',
  read_review: 'CSSBuy Review lesen',
  shipping_cost: 'CSSBuy Versandkosten',
  shipping_desc: 'Die Kosten variieren je nach Gewicht, Abmessungen, Ziel und Versandmethode.',
  view_shipping_guide: 'Versandkosten-Anleitung',
  coupon: 'CSSBuy Coupon & Rabattcode',
  coupon_desc: 'Überprüfen Sie Informationen zu Coupons und Aktionen. Bestätigen Sie die Gültigkeit immer direkt auf der Plattform.',
  view_coupons: 'Coupons & Rabatte ansehen',
  warehouse: 'CSSBuy Lager-Anleitung',
  warehouse_desc: 'Verstehen Sie Lagerung, QC, Konsolidierung und Bestellvorbereitung.',
  safety: 'Ist CSSBuy seriös und sicher?',
  safety_desc: 'Erklärt Risiken im Zusammenhang mit Verkäufern, Zahlungen, externen Links, QC, Versand, Zoll und Rückerstattungen.',
  view_safety_guide: 'CSSBuy Safety Guide ansehen',
  comparison: 'CSSBuy vs andere Plattformen',
  comparison_desc: 'Vergleichen Sie CSSBuy, Superbuy, Sugargoo, Oopbuy, AllChinaBuy und andere relevante Plattformen.',
  latest_articles: 'Neueste Artikel',
  faq: 'FAQ',
  faq_what_is: 'Was ist CSSBuy Spreadsheet?',
  faq_how_to_use: 'Wie verwende ich CSSBuy Spreadsheet?',
  faq_legit: 'Ist CSSBuy seriös?',
  faq_safe: 'Ist CSSBuy sicher?',
  faq_shipping_cost: 'Wie viel kostet der Versand?',
  faq_qc: 'Wie funktioniert QC?',
  faq_warehouse: 'Was ist Lager?',
  faq_find_products: 'Wie finde ich Produkte?',
  faq_brazil: 'Versendet CSSBuy nach Brasilien?',
  faq_coupons: 'Wo finde ich Coupons?',
  final_cta: 'Bereit, CSSBuy Spreadsheet zu erkunden?',
  final_cta_desc: 'Suchen Sie Produkte, vergleichen Sie Informationen und prüfen Sie unsere Anleitungen, bevor Sie zur Hauptwebsite wechseln.',
  footer_about: 'Über uns',
  footer_contact: 'Kontakt',
  footer_disclaimer: 'Haftungsausschluss',
  footer_privacy: 'Datenschutz',
  footer_terms: 'Nutzungsbedingungen',
  footer_rights: 'Alle Rechte vorbehalten.',
  article_read_more: 'Mehr lesen',
  article_spreadsheet_guide: 'CSSBuy Spreadsheet 2026 — Vollständige Anleitung',
  article_spreadsheet_desc: 'Entdecken Sie alles über CSSBuy Spreadsheet: wie Sie Produkte finden, Filter nutzen, QC überprüfen und Preise vergleichen. Aktualisierte Anleitung für 2026.',
  article_shipping_guide: 'CSSBuy Versandkosten-Anleitung 2026',
  article_shipping_guide_desc: 'Verstehen Sie die Versandkosten, verfügbare Methoden, Lieferzeiten und wie Sie die Fracht nach Brasilien und Europa berechnen.',
  article_safety_guide: 'Ist CSSBuy sicher? Safety Guide',
  article_safety_guide_desc: 'Vollständige Analyse zu Sicherheit, Verkäuferrisiken, Zahlungsschutz und wie Sie Probleme vermeiden.',
  spreadsheet_page_title: 'CSSBuy Spreadsheet 2026 — Vollständiger Produkt- & Kauf-Guide',
  what_is_spreadsheet: 'Was ist CSSBuy Spreadsheet?',
  how_it_works: 'Wie es funktioniert',
  how_to_find: 'Wie Produkte finden',
  product_categories: 'Produktkategorien',
  seller_research: 'Verkäufer-Recherche',
  latest_updates: 'Neueste Updates',
  cta: 'Zur Hauptwebsite weiterleiten',
  category_filter: 'Nach Kategorie filtern',
  price_filter: 'Preis',
  popularity_filter: 'Popularität',
  qc_filter: 'QC',
  seller_filter: 'Verkäufer',
  update_filter: 'Aktualisierung',
  streetwear: 'Streetwear',
  sportswear: 'Sportswear',
  clothing: 'Kleidung',
  sneakers: 'Sneakers',
  back_to_home: 'Zurück zur Startseite',
  published_date: 'Veröffentlicht',
  updated_date: 'Aktualisiert',
  author: 'Autor',
  sources: 'Quellen',
  related_articles: 'Verwandte Artikel',
  table_of_contents: 'Inhaltsverzeichnis',
  disclaimer_text: 'Dies ist eine unabhängige Informationswebsite und nicht die offizielle CSSBuy-Website. Alle externen Links führen zur Hauptwebsite.',
  view_guide: 'Anleitung ansehen',
  continue_to_main: 'Zur Hauptwebsite weiterleiten',
  learn_more: 'Mehr erfahren',
  read_article: 'Artikel lesen',
  see_all: 'Alle ansehen',
  search_results: 'Suchergebnisse',
  no_results: 'Keine Ergebnisse gefunden',
  all_categories: 'Alle Kategorien',
  spreadsheet_seo_title: 'CSSBuy Spreadsheet 2026 — Produkte finden und vergleichen',
  spreadsheet_seo_desc: 'Entdecken Sie CSSBuy Spreadsheet, finden Sie Produkte, vergleichen Sie Optionen und sehen Sie Anleitungen zu QC, Versand, Kosten, Lager, Sicherheit und Einkauf.',
  article_category_spreadsheet: 'CSSBuy Spreadsheet',
  article_category_shipping: 'Versand',
  article_category_safety: 'Sicherheit',
  article_category_review: 'Review',
  article_category_coupon: 'Coupons',
  article_category_warehouse: 'Lager',
  article_category_qc: 'Qualitätskontrolle',
  article_category_comparison: 'Vergleich',
  article_category_beginner: 'Anfänger-Anleitung',
  shopping_guide: 'Einkaufsführer',
  latest_articles_desc: 'Originale Kaufanleitungen, Bewertungen und Versandressourcen für CSSBuy Spreadsheet-Nutzer.',
  categories_desc: 'Durchsuchen Sie alle Produktkategorien der CSSBuy Spreadsheet und gelangen Sie direkt zu dem, was Sie brauchen.',
  article_review_title: 'CSSBuy Review 2026: Gebühren, QC, Versand & Sicherheit',
  article_review_desc: 'Ehrliche CSSBuy-Bewertung zu Gebühren, QC-Fotos, Lager, Versandkosten und Sicherheit. Ist CSSBuy seriös? Lesen Sie unsere Analyse 2026.',
  article_coupon_title: 'CSSBuy Coupon & Rabattcode 2026 — Anleitung',
  article_coupon_desc: 'Finden Sie Informationen zu CSSBuy-Coupons und Rabattcodes für 2026. Erfahren Sie, wie Aktionen funktionieren und wie Sie Angebote prüfen.',
  article_warehouse_title: 'CSSBuy Lager-Anleitung: Lagerung, QC & Versand',
  article_warehouse_desc: 'Vollständige CSSBuy-Lageranleitung zu Lagerung, QC-Prüfung, Konsolidierung und Paketvorbereitung vor dem Versand.',
  article_qc_title: 'CSSBuy QC-Anleitung: So lesen Sie QC-Fotos',
  article_qc_desc: 'Lernen Sie, CSSBuy-QC-Fotos zu lesen und Qualitätsprobleme vor dem Versand zu erkennen. Vollständige Checkliste für Schuhe und Kleidung.',
  article_alternatives_title: 'CSSBuy Alternatives 2026: Superbuy, Sugargoo & mehr',
  article_alternatives_desc: 'Vergleichen Sie CSSBuy mit Superbuy, Sugargoo, Oopbuy und AllChinaBuy. Finden Sie den besten Agenten für Ihre Bedürfnisse 2026.',
  article_beginner_title: 'So nutzen Sie CSSBuy Spreadsheet: Anfänger-Anleitung',
  article_beginner_desc: 'Neu bei CSSBuy? Diese Anfänger-Anleitung erklärt, wie Sie die Spreadsheet nutzen, Produkte finden, QC prüfen und Ihre erste Bestellung versenden.',
  article_brazil_title: 'CSSBuy Versand nach Brasilien: Kosten & Zoll',
  article_brazil_desc: 'CSSBuy-Versand nach Brasilien erklärt: Methoden, Kosten, Lieferzeiten und Zollgebühren. Vollständige Anleitung für brasilianische Käufer.',
  article_germany_title: 'CSSBuy Versand nach Deutschland: Kosten & Methoden',
  article_germany_desc: 'CSSBuy-Versand nach Deutschland: verfügbare Methoden, Kosten, Lieferzeiten und Zollinformationen für deutsche Käufer.',
  article_shoes_title: 'CSSBuy Spreadsheet Schuhe: Beste Sneaker-Funde',
  article_shoes_desc: 'Entdecken Sie die besten Schuhe und Sneaker in der CSSBuy Spreadsheet. Stöbern Sie nach beliebten Funden, vergleichen Sie Verkäufer und prüfen Sie QC.',
  article_hoodies_title: 'CSSBuy Spreadsheet Hoodies: Beste Funde & Anleitung',
  article_hoodies_desc: 'Stöbern Sie nach den besten Hoodies und Pullovern in der CSSBuy Spreadsheet. Finden Sie beliebte Styles, vergleichen Sie Verkäufer und prüfen Sie QC-Fotos.',
  featured_products: 'Ausgewählte Produkte',
  featured_products_desc: 'Handverlesene Produkte aus der CSSBuy Spreadsheet. Klicken Sie auf ein Element, um Details anzuzeigen und zu kaufen.',
  all_products: 'Alle Produkte anzeigen',
  products: 'Produkte',
  filter_all: 'Alle',
  back_to_top: 'Zurück nach oben',
  products_title: 'CSSBuy Spreadsheet Produkte',
  products_subtitle: 'Entdecken Sie alle Produkte der CSSBuy Spreadsheet. Filtern Sie nach Kategorien und klicken Sie auf ein Element, um Details anzuzeigen und zu kaufen.',
};